import { v4 as uuidv4 } from 'uuid';

export const getUniqueKey = (identifyingString?: string): string => {
	if (!identifyingString) return `${uuidv4()}`;

	return `${identifyingString}-${uuidv4()}`;
};
